import React from 'react';
import * as FeatureTypes from 'pages/Features/typings';
import * as Types from './typings';
import { Fields } from 'types/FormValue';

import OrgChartHighlightsLayout from './OrgChartHighlightsLayout';
import OrgChartExport from './OrgChartExport';
import RootNodes from './RootNodes';
import ModernViewCustomContent from './ModernViewCustomContent';
import SortableAttributes from './SortableAttributes';
import DefaultOrgChartStartingPosition from './DefaultOrgChartStartingPosition';
import DefaultOrgChartAttrSettings from './DefaultOrgChartAttrSettings';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  values: FeatureTypes.FeatureValues;
  rootNodes: Types.rootNodes;
  userStatus: number;
  fields: Fields;
}

function OrgChart({ setFieldValue, values, rootNodes, userStatus, fields }: Props) {
  return (
    <>
      <ModernViewCustomContent
        fields={Object.values(fields)}
        values={values}
        userStatus={userStatus}
        onChange={setFieldValue}
      />

      <DefaultOrgChartStartingPosition values={values} onChange={setFieldValue} />

      <DefaultOrgChartAttrSettings
        fields={Object.values(fields)}
        values={values}
        userStatus={userStatus}
        onChange={setFieldValue}
      />

      <SortableAttributes
        fields={Object.values(fields)}
        values={values}
        userStatus={userStatus}
        onChange={setFieldValue}
      />

      <OrgChartHighlightsLayout
        onChange={setFieldValue}
        userStatus={userStatus}
        fields={Object.values(fields)}
        values={values}
      />
      <OrgChartExport onChange={setFieldValue} value={values.client.settings.orgChart} />
      <RootNodes
        onChange={setFieldValue}
        availableRootNodes={rootNodes}
        currentRootNodes={values.client.settings.orgChart}
      />
    </>
  );
}

export default OrgChart;
